/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthSessionR
 */
export interface AuthSessionR {
    /**
     * NO_DESCRIPTION
     * @type {number}
     * @memberof AuthSessionR
     */
    id: number;
    /**
     * NO_DESCRIPTION
     * @type {string}
     * @memberof AuthSessionR
     */
    username: string;
}

/**
 * Check if a given object implements the AuthSessionR interface.
 */
export function instanceOfAuthSessionR(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function AuthSessionRFromJSON(json: any): AuthSessionR {
    return AuthSessionRFromJSONTyped(json, false);
}

export function AuthSessionRFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthSessionR {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
    };
}

export function AuthSessionRToJSON(value?: AuthSessionR | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
    };
}

